import { render, staticRenderFns } from "./subordinateBody.vue?vue&type=template&id=575c6f9d&"
import script from "./subordinateBody.vue?vue&type=script&lang=ts&"
export * from "./subordinateBody.vue?vue&type=script&lang=ts&"
import style0 from "./subordinateBody.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports